module.exports = __webpack_public_path__ + "img/2gis.085fca07.png";